export default __webpack_public_path__ + "static/media/no_users.e7893ac0.svg";